import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router.js';
import VueRouter from 'vue-router';
import filters from './filters.js';
import Vuikit from 'vuikit';
import VuikitIcons from '@vuikit/icons';
import '@vuikit/theme';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import BootstrapVue from 'bootstrap-vue';
import VueAnalytics from 'vue-analytics'
import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(VueAnalytics, {
  id: 'UA-155049334-1',
  router
});

// import axios from 'axios';
// window.axios = axios;
// window.axios.defaults.headers.common = {
//   'X-Requested-With': 'XMLHttpRequest',
//   'Accept': 'application/json',
// };
// window.axios.defaults.withCredentials = true;
// window.axios.defaults.baseURL = process.env.VUE_APP_API_ROOT;
// window.axios.interceptors.response.use((response) => {
//   return response;
// }, error => {
//   if (!window.axios.isCancel(error)) {
//     if (!error.response) return;
//     let originalRequest = error.config;
//     if (error.response.status === 401 && !originalRequest._retry) { // if the error is 401 and hasent already been retried
//       // router.push({path: '/'});
//     } else if (error.response.status === 403) {
//       window.SAize.toast('この操作（データに対する登録・編集・閲覧など）の権限がありません。詳細は管理者までお尋ねください。');
//     } else if (error.response.status === 412) {
//       // 連続時間制限エラー
//       window.SAize.toast(error.response.body);
//     } else if (error.response.status === 422) {
//       window.SAize.toast('SQLエラー【新規登録に失敗しました】' + error.response.data.errors.name.join(''));
//     }
//   }
//   return Promise.reject(error);
// });

Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(Vuikit);
Vue.use(VuikitIcons);
Vue.use(Vue2TouchEvents);

import infiniteScroll from 'vue-infinite-scroll';
Vue.use(infiniteScroll);

import SwipeMenu from 'vue-swipe-menu';
Vue.use(SwipeMenu);

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    calcPrice: function (width, height, fileSize=null, colorMulti=1, sendPrice=null) {
      if (!this.$store.state.price) return;
      width = width / 10;
      height = height / 10;
      const fileSizeK = (fileSize / 1024).toFixed(2);
      // window.console.log('計算スタート(width, height):', width, height, fileSize, colorMulti);
      const longRectangle = Math.max(width, height);
      const shortRectangle = Math.min(width, height);

      const longRectangleVal = Math.max(longRectangle, this.$store.state.price.minShort); // 長辺15cmが最低価格
      const shortRectangleVal = (longRectangleVal > this.$store.state.price.minShort) ?
        shortRectangle :
        this.$store.state.price.minShort / longRectangle * shortRectangle; // 長辺が15cm以下なら短辺は長辺１５cmの時のサイズにする

      const getRectangleMulti = (val, arr) => {
        let found = 0;
        Object.keys(arr).some(k => {
          const min = arr[k][0];
          const max = arr[k][1];
          const multi = arr[k][2];
          if (val >= min && val <= max) {
            found = multi;
            return true;
          }
          found = multi;
        });
        return found;
      };
      const convertFileSize = (fileSize) => {
        return Math.sqrt(fileSize).toFixed(2);
      };

      const longRectangleMulti = getRectangleMulti(longRectangleVal, this.$store.state.price.longMulti);
      const shortRectangleMulti = getRectangleMulti(shortRectangleVal, this.$store.state.price.shortMulti);
      const convertedFileSize = convertFileSize(fileSizeK);
      if (sendPrice === null) sendPrice = this.$store.state.price.sendPrice;
      const priceMathDigit = this.$store.state.price.priceMathDigit;

      let price = (
        longRectangleVal * shortRectangleVal * convertedFileSize * shortRectangleMulti * longRectangleMulti + sendPrice
        ) * colorMulti;
      price = Math.floor(price / priceMathDigit) * priceMathDigit;
      // const comment = `長辺(${longRectangle}=>${longRectangleVal})×短辺(${shortRectangle}=>${shortRectangleVal})×√容量kB(${fileSizeK}=>${convertedFileSize})×短辺係数(${shortRectangleMulti})×長辺係数(${longRectangleMulti})×色係数(${colorMulti})+基本料(${sendPrice})=${price}`;
      // window.console.log(comment);
      return price;
    },
  }
});

// router.beforeEach((to, from, next) => {
//   if (to.path !== '/') {  // ログインして1日以上経過していたらデータ同期のため強制的にTOPにする
//     // store.state.atLogin === null
//     const now = new Date();
//     const date = new Date(store.state.atLogin);
//     date.setDate(date.getDate() + 1);
//     const timeout = (now.getTime() > date.getTime());
//     if (timeout) {
//       next ('/')
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
// })

new Vue({
  store,
  router,
  filters: {...filters},
  render: h => h(App)
}).$mount('#app');
